import axios from 'axios';
import { apiUrl } from '../constants';

const authConfig = (accessToken, config = {}) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${accessToken}`,
  },
});

export const getWipMaster = (scope, accessToken) => axios.get(
  apiUrl.WIP_MASTER,
  authConfig(accessToken, { params: scope }),
);

export const getWipMasterOptions = ({ plant_id, factory }, accessToken) => axios.get(
  apiUrl.WIP_MASTER_OPTIONS,
  authConfig(accessToken, { params: { plant_id, factory } }),
);

export const getWipRegistrations = (scope, accessToken) => axios.get(
  apiUrl.WIP_REGISTER,
  authConfig(accessToken, { params: scope }),
);

export const getWipRegistration = (id, accessToken, params = {}) => axios.get(
  `${apiUrl.WIP_REGISTER}${id}/`,
  authConfig(accessToken, { params }),
);

export const createWipRegistration = (payload, accessToken) => axios.post(
  apiUrl.WIP_REGISTER,
  payload,
  authConfig(accessToken),
);

export const deleteWipRegistration = (id, accessToken) => axios.delete(
  `${apiUrl.WIP_REGISTER}${id}/`,
  authConfig(accessToken),
);

export const getWipMobileScans = (scope, accessToken) => axios.get(
  apiUrl.WIP_MOBILE_SCAN,
  authConfig(accessToken, { params: { ...scope, ordering: '-scanned_at', page_size: 10 } }),
);

export const createWipMobileScan = (payload, accessToken) => axios.post(
  apiUrl.WIP_MOBILE_SCAN,
  payload,
  authConfig(accessToken),
);

export const deleteWipMobileScan = (id, accessToken) => axios.delete(
  `${apiUrl.WIP_MOBILE_SCAN}${id}/`,
  authConfig(accessToken),
);

